import axios from "axios";

// Create an axios instance for PHP API calls
const api = axios.create({
  baseURL: "https://hrms.urbango.co.in/server/index.php",
});

// Example login API for PHP backend
export const login = async (username, password) => {
  try {
    const res = await api.post("?endpoint=login", { username, password });
    return res.data;
  } catch (err) {
    console.error("Login error:", err);
    throw err;
  }
};

// Example mark attendance API for PHP backend
export const markAttendance = async (employeeId, date, month, status, checkIn, checkOut, duration, employeeName) => {
  try {
    const res = await api.post("?endpoint=attendance", {
      date, month, status, checkIn, checkOut, duration, employeeName
    });
    return res.data;
  } catch (err) {
    console.error("Attendance error:", err);
    throw err;
  }
};

// Example leave request API for PHP backend
export const requestLeave = async (startDate, endDate, employee, leaveType, reason) => {
  try {
    const res = await api.post("?endpoint=leave", {
      startDate, endDate, employee, leaveType, reason
    });
    return res.data;
  } catch (err) {
    console.error("Leave request error:", err);
    throw err;
  }
};

export default api;
